import { CloudDeliveryPromiseType } from "@omni/types/api/product/cloud/shared/enums/deliveryPromiseType.enum";
import { CloudProductAvailability } from "@omni/types/api/store/cloud/shared/productAvailability.model";

export const shouldDisableAddToCart = (
    productAvailability?: null | CloudProductAvailability
): boolean => {
    if (
        productAvailability?.deliveryPromiseType &&
        [
            CloudDeliveryPromiseType.AvailableForS2S,
            CloudDeliveryPromiseType.AvailableForHomeDelivery
        ].includes(productAvailability?.deliveryPromiseType)
    ) {
        return false;
    }

    if (
        !productAvailability?.realTimeStockAvailable &&
        productAvailability?.enableAddToCart
    ) {
        return false;
    }

    if (
        productAvailability?.realTimeStockAvailable &&
        productAvailability?.realTimeStock! > 0
    ) {
        return false;
    }

    return true;
};
